import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

// Model //
import CalculationFomulaModal from './CalculationFormulaModal';
import MemberList from './MemberList';
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation //

// Image //
import ReRegistrationImagePath from '../../../image/ReRegistration.png';
import LeaveMemberImagePath from '../../../image/LeaveMember.png';
// Image //


const MemberMovementHistoryBox = (props) => {
  const {
    salesData,
    startDate,
    endDate,
    calcDateText,
    allMembers,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isLoadingAllMember,
    isReregistLoading,
    setIsReregistLoading,
    isExpiredLoading,
    setIsExpiredLoading
  } = props;

  const [reRegistMembers, setReRegistMembers] = useState([]);
  const [aliveMembers, setAliveMembers] = useState([]);
  const [leaveMembers, setLeaveMembers] = useState([]);
  const [reregistPrice, setReregistPrice] = useState(0);
  const [isViewLeaveMemberRateModal, setIsViewLeaveMemberRateModal] = useState(false);
  const [isViewReregistMemberRateModal, setIsViewReregistMemberRateModal] = useState(false);

  // 이탈 회원, 재등록 회원 구분 //
  useEffect(() => {
    if (isLoadingAllMember) return;

    let newReregistMembers = [];
    let newAliveMembers = [];
    let newLeaveMembers = [];

    for (let i = 0; i < allMembers.length; i++) {
      let isReregist = false;
      let isAlive = false;
      let isLeave = false;

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].startDate) || startDate.isSame(allMembers[i].usages[j].startDate))
          && (endDate.isAfter(allMembers[i].usages[j].startDate) || endDate.isSame(allMembers[i].usages[j].startDate))
          && allMembers[i].usages.length > 1) {
          allMembers[i].startDate = allMembers[i].usages[j].startDate;
          isReregist = true;
          break;
        }
      }

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if (endDate.isBefore(allMembers[i].usages[j].endDate)) {
          isAlive = true;
          break;
        }
      }

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if (j === allMembers[i].usages.length - 1
          && startDate.isBefore(allMembers[i].usages[j].endDate)
          && endDate.isAfter(allMembers[i].usages[j].endDate)) {
          allMembers[i].endDate = allMembers[i].usages[j].endDate;
          isLeave = true;
          break;
        }
      }

      if (isReregist) newReregistMembers.push(allMembers[i]);
      if (isAlive) newAliveMembers.push(allMembers[i]);
      if (isLeave) newLeaveMembers.push(allMembers[i]);
    }

    newReregistMembers.sort(function (a, b) {
      let x = a.startDate;
      let y = b.startDate;

      if (x < y) return 1;
      if (x > y) return -1;
    })

    newLeaveMembers.sort(function (a, b) {
      let x = a.endDate;
      let y = b.endDate;

      if (x < y) return 1;
      if (x > y) return -1;
    })

    setReRegistMembers(newReregistMembers);
    setAliveMembers(newAliveMembers);
    setLeaveMembers(newLeaveMembers);

    setTimeout(() => {
      setIsReregistLoading(false);
      setIsExpiredLoading(false);
    }, 1000)
  }, [startDate, endDate, allMembers, isLoadingAllMember])

  useEffect(() => {
    if (salesData.length === 0 || allMembers.length === 0) return;

    let reRegistMembers = [];
    let newReregistPrice = 0;

    for (let i = 0; i < allMembers.length; i++) {
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].approvalDate) || startDate.isSame(allMembers[i].usages[j].approvalDate))
          && (endDate.isAfter(allMembers[i].usages[j].approvalDate) || endDate.isSame(allMembers[i].usages[j].approvalDate))
          && allMembers[i].usages.length > 1) {
          reRegistMembers.push(allMembers[i]);
          break;
        }
      }
    }

    for (let i = 0; i < salesData.length; i++) {
      let isExist = false;

      for (let j = 0; j < reRegistMembers.length; j++) {
        if (salesData[i].memberId === reRegistMembers[j].memberId) {
          isExist = true;
          break;
        }
      }

      if (isExist) {
        newReregistPrice += (salesData[i].cardPrice + salesData[i].cashPrice);
      }

    }

    setReregistPrice(newReregistPrice);
  }, [salesData, allMembers])

  // 회원 이탈율 호버링시 //
  function onMouseOverLeaveMemberRate() {
    setIsViewLeaveMemberRateModal(true);
  }

  // 회원 이탈율 호버링시 //
  function onMouseLeaveLeaveMemberRate() {
    setIsViewLeaveMemberRateModal(false);
  }

  // 회원 재등록율 호버링시 //
  function onMouseOverReregistMemberRate() {
    setIsViewReregistMemberRateModal(true);
  }

  // 회원 재등록율 호버링시 //
  function onMouseLeaveReregistMemberRate() {
    setIsViewReregistMemberRateModal(false);
  }


  return (
    <TopLevelWrapper>
      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{calcDateText() + ' 이탈 회원'}</Text>
        {
          isExpiredLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <LeaveIcon src={LeaveMemberImagePath} />
                      <LeavePersent onMouseOver={onMouseOverLeaveMemberRate} onMouseLeave={onMouseLeaveLeaveMemberRate}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>회원 이탈율</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{Math.round((leaveMembers.length / aliveMembers.length) * 100)}%</Text>
                      </LeavePersent>
                      <CalculationFomulaModal
                        isView={isViewLeaveMemberRateModal}
                        denominator={leaveMembers.length.toLocaleString('ko-KR')}
                        denominatorText='(산정기간 만료회원 수)'
                        numerator={aliveMembers.length.toLocaleString('ko-KR')}
                        numeratorText='(산정기간 유효회원)'
                        result={Math.round((leaveMembers.length / aliveMembers.length) * 100)}
                        resultUnit='%'
                        innerBoxBackgroundColor='#C15D24'
                        componentBoxBackgroundColor='#FF8B48' />
                      <DivisionLine />
                      <ResultBox>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>총</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#777777' cursor='default'>{leaveMembers.length}명</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>이탈</Text>
                      </ResultBox>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='default'>이탈 회원 목록</Text>
                    </ListTitleWrapper>
                    <MemberList column='이탈 날짜' data={leaveMembers} selectedPartnerGym={selectedPartnerGym} />
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>이 업체는 파트너 체육관에 매출을 비공개 합니다</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>링크존 설정에서 “파트너 체육관”에서 권한 설정해 주세요</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>

      <BoxDivisionLine />

      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{calcDateText() + ' 신규등록 회원'}</Text>
        {
          isReregistLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <LeaveIcon src={ReRegistrationImagePath} />
                      <ReRegistrationPersent onMouseOver={onMouseOverReregistMemberRate} onMouseLeave={onMouseLeaveReregistMemberRate}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>회원 재등록율</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{Math.round((reRegistMembers.length / aliveMembers.length) * 100)}%</Text>
                      </ReRegistrationPersent>
                      <CalculationFomulaModal
                        isView={isViewReregistMemberRateModal}
                        denominator={reRegistMembers.length.toLocaleString('ko-KR')}
                        denominatorText='(산정기간 재등록 회원 수)'
                        numerator={aliveMembers.length.toLocaleString('ko-KR')}
                        numeratorText='(산정기간 유효회원)'
                        result={Math.round((reRegistMembers.length / aliveMembers.length) * 100)}
                        resultUnit='%'
                        innerBoxBackgroundColor='#4195C3'
                        componentBoxBackgroundColor='#65C5FA' />
                      <DivisionLine />
                      <ResultBox>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>총</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#777777' cursor='default'>{reRegistMembers.length}명</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>재등록</Text>
                      </ResultBox>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='default'>재등록 회원 목록</Text>
                      <PriceTextWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#BABABA' cursor='default'>재등록 회원 매출</Text>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='default'>{reregistPrice.toLocaleString('ko-KR')}</Text>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#BABABA' cursor='default'>원</Text>
                      </PriceTextWrapper>
                    </ListTitleWrapper>
                    <MemberList column='등록 날짜' data={reRegistMembers} selectedPartnerGym={selectedPartnerGym} />
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>이 업체는 파트너 체육관에 매출을 비공개 합니다</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>링크존 설정에서 “파트너 체육관”에서 권한 설정해 주세요</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default MemberMovementHistoryBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 38px;
  
  width: 1020px;
  height: 448px;

  gap: 28px;

  border-radius: 30px;
  box-shadow: 0 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const BoxDivisionLine = styled.div`
  diplay: flex;
  flex-direction: row;

  width: 1px;
  height: 392px;

  background-color: #ECECEC;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;

  width: 44.5%;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 364px;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
  height: 364px;

  z-index: 5;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const TopUIWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

const LeaveIcon = styled.img`
  width: 48px;
  height: 48px;

  margin-right: 8px;
`;

const LeavePersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: #FF8B48;

  &:hover {
    cursor: pointer;
  }
`;

const ReRegistrationPersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  border-radius: 8px;
  background-color: #33C8FF;

  &:hover {
    cursor: pointer;
  }
`;


const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: 120px;
  height: 1px;

  margin: 0 16px 0 16px;
  border: 1px solid #ECECEC;
`;

const ResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 113px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: #ECECEC;
`;

const ListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 24px;

  width: 100%;
`;

const PriceTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  gap: 4px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;